export const expenseDetailsRoutes = [
  {
    path: 'expense-batch-pdf',
    name: 'expense-batch-pdf',
    component: () =>
      import(/* webpackChunkName: "expense-details-pdf" */ './components/ExpensesBatchPDF.vue')
  },
  {
    path: ':id',
    name: 'expense-details',
    component: () => import(/* webpackChunkName: "expense-details" */ './ExpenseDetails.vue')
  }
];
